export interface Save {
  id: string;
  userId: string;
  establishmentId: string;
}
